import { useEffect, useRef } from 'react'
import { useStats } from '../ctx/stats'
import { useStatsPermission } from './useStatsPermission'
import { analytics } from 'segment_analytics'
import { isOnboardingView } from '../utils'

export const useStatsAnalytics = () => {
  const stats = useStats((s) => s.stats)
  const { isStatsOwner } = useStatsPermission()
  const sent = useRef(false)

  useEffect(() => {
    if (!!stats && !sent.current) {
      analytics.events.stats.statsViewed({
        view_type: isStatsOwner ? 'self' : 'other',
        goal_set: !!stats?.reading_goal,
        books_read: stats?.reading_goal?.number_achieved || 0,
        starting_from: isOnboardingView ? 'onboarding' : 'stats_page',
      })

      sent.current = true
    }
  }, [stats, isStatsOwner])
}
